/**
 * Third-party software and fonts shipped with Phiedit, with their licences (W2-13 settings-keymap; Settings >
 * About & licences). Names, licences and homepages as declared by each package; what each is used for is
 * translated.
 */

import type { MessageKey } from '../../i18n/types';
import { m } from './settings.messages';

export interface LicenceEntry {
  readonly name: string;
  /** SPDX identifier. */
  readonly licence: string;
  readonly url: string;
  readonly use: MessageKey;
}

export const LIBRARIES: readonly LicenceEntry[] = [
  { name: 'React, React DOM', licence: 'MIT', url: 'https://react.dev', use: m.useReact },
  { name: 'Radix UI Primitives', licence: 'MIT', url: 'https://www.radix-ui.com/primitives', use: m.useRadix },
  { name: 'Lucide', licence: 'ISC', url: 'https://lucide.dev', use: m.useLucide },
  { name: 'TanStack Virtual', licence: 'MIT', url: 'https://tanstack.com/virtual', use: m.useVirtual },
  {
    name: 'react-resizable-panels',
    licence: 'MIT',
    url: 'https://github.com/bvaughn/react-resizable-panels',
    use: m.usePanels,
  },
  { name: 'cmdk', licence: 'MIT', url: 'https://github.com/pacocoursey/cmdk', use: m.useCmdk },
  { name: 'Zustand', licence: 'MIT', url: 'https://github.com/pmndrs/zustand', use: m.useZustand },
  { name: 'fflate', licence: 'MIT', url: 'https://github.com/101arrowz/fflate', use: m.useFflate },
  { name: 'gifuct-js', licence: 'MIT', url: 'https://github.com/matt-way/gifuct-js', use: m.useGif },
  { name: 'idb', licence: 'ISC', url: 'https://github.com/jakearchibald/idb', use: m.useIdb },
  { name: 'yaml', licence: 'ISC', url: 'https://eemeli.org/yaml/', use: m.useYaml },
];

export const FONTS: readonly LicenceEntry[] = [
  {
    name: 'Noto Sans SC',
    licence: 'OFL-1.1',
    url: 'https://fonts.google.com/noto/specimen/Noto+Sans+SC',
    use: m.useNotoSc,
  },
  { name: 'Noto Sans', licence: 'OFL-1.1', url: 'https://fonts.google.com/noto/specimen/Noto+Sans', use: m.useNoto },
  { name: 'Saira', licence: 'OFL-1.1', url: 'https://fonts.google.com/specimen/Saira', use: m.useSaira },
];

export const DOCUMENTS: readonly LicenceEntry[] = [
  {
    name: 'Phira documentation (TeamFlos/phira-docs)',
    licence: 'CC-BY-4.0',
    url: 'https://github.com/TeamFlos/phira-docs',
    use: m.usePhiraDocs,
  },
];

/** Where the full licence texts live (SPDX). */
export function licenceUrl(spdx: string): string {
  return `https://spdx.org/licenses/${spdx}.html`;
}
